"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsBotTraffic = void 0;
const botKeywords_1 = require("./botKeywords");
const getIsBotTraffic = (userAgent) => {
    const lowerCaseUserAgent = userAgent.toLowerCase();
    const isBot = botKeywords_1.BOT_KEYWORDS.some((keyword) => lowerCaseUserAgent.includes(keyword));
    return isBot;
};
exports.getIsBotTraffic = getIsBotTraffic;
